<template>
  <div class="w-full bord">
    <div class="w-full flex justify-between gap-5">
      <div class="w-2/3 bg-white rounded-14 p-5">
        <div class="text-left">
          <div class="text-c26 font-c7 flex items-end">
            Evolution d’inscription
          </div>
        </div>
        <div>
          <inscriptStat />
        </div>
      </div>
      <div class="w-1/3">
        <detailsNombre
          :stats="stats"
          :account-data="accountData"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import apiroutes from '../../../router/api-routes'
// import http from '../../../plugins/https'
import user from "../../../assets/icons/ic-clientAv.svg";
import entreprise from "../../../assets/icons/ic-entreprise.svg";
import inscriptStat from "./inscriptStat.vue";
import detailsNombre from "./detailsNombre.vue";
import calendar from "../../../assets/icons/calendar.svg"

// import store from '../../../store'

export default {
  name: "Index",
  components: {
    inscriptStat,
    detailsNombre,
  },

  props: {
    stats: {
      type: Object,
      required: true,
    },
    accountData: {
      type: Object,
      required: true,
    },
    flow: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      icons: {
        user,
        entreprise,
        calendar
      },
      allStat: null,
    };
  },

  methods: {},
};
</script>

<style scoped></style>
